<template>
    <div class="experience">
        <div v-if="banner && banner.length" class="experience-banner">
            <img :src="img.logo" v-for="img in banner" :key="img.logo" alt="" @click="openBanner(img.url)">
        </div>
        <div class="experience-body">
            <div class="experience-tabs">
                <Tabs :tabsList="tabsList" :activeType="activeType" @handleTab="handleTab" />
            </div>
            <!-- 经验列表 -->
            <experience-list :type="activeType"></experience-list>
        </div>
    </div>
</template>

<script>
import { getArticleTypes } from '@/api/experience';
import { getBannerURL } from '@/api/common';
import ExperienceList from './components/ExperienceList';
import Tabs from '@/components/Tabs';

export default {
    name: 'Experience',
    components: {
        ExperienceList,
        Tabs
    },
    data: () => ({
        tabsList: [
            {
                type: 'all',
                title: '全部经验'
            }
        ],
        banner: null,
        activeType: sessionStorage.getItem('expirenceTab') || 'all',
    }),
    mounted() {
        this.getTabs()
        this.getBannerURL();
    },
    methods: {
        openBanner(imgUrl) {
            window.open(imgUrl);
        },
        // 获取banner图地址
        getBannerURL() {
            getBannerURL(7).then(({ data }) => {
                this.banner = (data || []).splice(0,2);
            });
        },
        getTabs() {
            getArticleTypes().then(({ code, data }) => {
                if (code === 0) {
                    const tabsList = data.map(({ id, name }) => {
                        return {
                            type: id,
                            title: name
                        };
                    });
                    this.tabsList = [
                        {
                            type: 'all',
                            title: '全部经验'
                        },
                        ...tabsList
                    ];
                }
            });
        },
        handleTab(type) {
            sessionStorage.setItem('expirenceTab', type)
            sessionStorage.setItem(this.$route.path, 1)
            this.activeType = type;
        }
    }
};
</script>

<style lang="scss" scoped>
.experience {
    &-tabs {
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(224, 228, 247, 1);
    }
    &-banner {
        // padding: 20px 0;
        // background-color: #fff;
        text-align: center;
        font-size: 0;
		display: flex;
		padding: 20px 0 0 0;
		width: 1600px;
		overflow: hidden;
		margin: 0 auto;
        > img {
            cursor: pointer;
            flex:1;
			margin-right: 20px;
			border-radius: 4px;
			height: 120px;
            font-size: 0;
			width: 790px;
			&:nth-last-child(1) {
				margin-right: 0;
			}
        }
    }
    
    &-body {
        margin: 0 auto;
        padding-top: 20px;
        width: 1600px;
    }
}

// 小屏
@include mq($small) {
    .experience {
        &-tabs {
            padding-bottom: 4px;
        }
        &-banner {
            width: 1200px;
        }
        &-body {
            width: 1200px;
        }
    }
}
</style>
